import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

// Track a CTA click (example: yoga, care, consult, book_appointment)

export const trackCTA = async (eventName, user, page = '') => {
  try {
    // 🔥 Debug: Log what we're sending
    console.log('🔥 CTA Tracking Debug:', {
      eventName,
      user: user ? 'exists' : 'null',
      account_id: user?.account_id,
      user_id: user?.id,
      page: page || window.location.pathname
    });

    // 🔥 Validate required data
    // 🔥 Validate required data
if (!user?.id) {
    console.error('❌ CTA Error: Missing user data', {
        hasUser: !!user,
        userId: user?.id
    });
    return null;
}

    if (!eventName) {
      console.error('❌ CTA Error: Missing event name');
      return null;
    }

    const payload = {
      account_id: user.account_id,
      user_id: user.id,
      event: eventName,
      page: page || window.location.pathname
    };

    console.log('🚀 Sending CTA payload:', payload);

    const response = await axios.post(`${API_BASE_URL}/user-cta`, payload);
    console.log('✅ CTA Response:', response.data);
    return response.data;
  } catch (error) {
    console.error("❌ Error tracking CTA:", error.response?.data || error.message);
    return null;
  }
};

// New hook for page view tracking
export const usePageTracking = () => {
  const location = useLocation();
  const { user } = useAuth();

  useEffect(() => {
    if (user?.id) {
      trackCTA('page_view', user, window.location.pathname);
    }
  }, [location, user]);
};